import { RefreshCw, WifiOff } from 'lucide-react';
import { useAppStatus } from '../lib/appStatus';
import { local, todayLocal } from '../lib/calendarDates';
import { applyUpdate } from '../lib/pwa';
import styles from './StatusBanner.module.css';

function copyTime(iso: string): string {
  const t = local(iso);
  return t.toISODate() === todayLocal() ? t.toFormat('HH:mm') : t.toFormat('d.MM, HH:mm');
}

/** "No connection, data from …" and "new version available" — visible on every screen. */
export function StatusBanner({ sticky = false }: { sticky?: boolean }) {
  const { online, offlineCopyAt, updateAvailable } = useAppStatus();
  if (online && !updateAvailable) return null;
  return (
    <div className={`${styles.stack} ${sticky ? styles.sticky : ''}`}>
      {!online && (
        <div className={styles.banner} role="status">
          <WifiOff aria-hidden="true" className={styles.icon} />
          <p className={styles.text}>
            <strong>Brak połączenia</strong>
            {offlineCopyAt
              ? `, dane z ${copyTime(offlineCopyAt)}. Możesz tylko przeglądać.`
              : '. Dane z tego urządzenia nie są jeszcze dostępne bez internetu.'}
          </p>
        </div>
      )}
      {updateAvailable && (
        <div className={styles.banner} role="status">
          <RefreshCw aria-hidden="true" className={styles.icon} />
          <p className={styles.text}>
            <strong>Dostępna nowa wersja aplikacji.</strong>
          </p>
          <button type="button" className={styles.action} onClick={applyUpdate}>
            Odśwież
          </button>
        </div>
      )}
    </div>
  );
}

